import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "custom-form-control"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-form-control" }),
  /*#__PURE__*/_createTextVNode(" Custom Form Control ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".form-control-solid"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createVNode("code", null, ".form-control"),
  /*#__PURE__*/_createTextVNode(" to set solid background style for a form control: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><label for=\"exampleFormControlInput1\" class=\"form-label\">Email address</label><input type=\"email\" class=\"form-control form-control-solid\" id=\"exampleFormControlInput1\" placeholder=\"name@example.com\"></div><div class=\"mb-10\"><label for=\"exampleFormControlTextarea1\" class=\"form-label\">Example textarea</label><textarea class=\"form-control form-control-solid\" id=\"exampleFormControlTextarea1\" rows=\"3\"></textarea></div>", 2)
const _hoisted_8 = { class: "py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="mb-10">
              <label for="exampleFormControlInput1" class="form-label"
                >Email address</label
              >
              <input
                type="email"
                class="form-control form-control-solid"
                id="exampleFormControlInput1"
                placeholder="name@example.com"
              />
            </div>

            <div class="mb-10">
              <label for="exampleFormControlTextarea1" class="form-label"
                >Example textarea</label
              >
              <textarea
                class="form-control form-control-solid"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}